module.exports = __webpack_public_path__ + "static/media/404-01.54e4859a.png";